export default __webpack_public_path__ + "static/media/russianbgwindows-tourn-01-01_11zon.c722ef60.webp";